import {NavLink} from 'react-router-dom';
import {useInvoices} from '../../../invoices';
import {Invoice} from '../../../invoices/types';
import {StatusBadge} from '../../../invoices/profile/StatusBadge';
import {
    Group,
    Paper,
    Stack,
    Table,
    Text,
    Title,
    Button,
} from '@mantine/core';

export const RecentInvoicesWidget = () => {

    const {items, loading} = useInvoices();

    return (
        <Paper shadow="sm" p="lg" radius="md" withBorder>
            <Stack gap="md">
                <Group justify="space-between">
                    <Title order={5}>Recent Invoices</Title>
                    <Button variant="subtle" size="xs" component={NavLink} to="/invoices">
                        View All
                    </Button>
                </Group>

                {loading ? (
                    <Text size="sm" c="dimmed">Loading...</Text>
                ) : items.length === 0 ? (
                    <Text size="sm" c="dimmed">No invoices yet</Text>
                ) : (
                    <Table verticalSpacing="xs" highlightOnHover>
                        <Table.Thead>
                            <Table.Tr>
                                <Table.Th>Number</Table.Th>
                                <Table.Th>Customer</Table.Th>
                                <Table.Th style={{textAlign: 'right'}}>Amount</Table.Th>
                                <Table.Th>Status</Table.Th>
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                            {items.map((item: Invoice) => (
                                <Table.Tr key={item.id}>
                                    <Table.Td>
                                        <NavLink to={`/invoices/${item.id}`}>
                                            <Text size="sm">{item.number || item.id}</Text>
                                        </NavLink>
                                    </Table.Td>
                                    <Table.Td>
                                        <Text size="sm">{item.customerName || item.customerId}</Text>
                                    </Table.Td>
                                    <Table.Td style={{textAlign: 'right'}}>
                                        <Text size="sm">{(item.amountDue / 100).toFixed(2)} {item.currency}</Text>
                                    </Table.Td>
                                    <Table.Td>
                                        <StatusBadge status={item.status}/>
                                    </Table.Td>
                                </Table.Tr>
                            ))}
                        </Table.Tbody>
                    </Table>
                )}
            </Stack>
        </Paper>
    );
};
